import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Project } from '@brg/api';
import { LayoutConst } from 'core';
import { AppTester } from 'supporting';
import {
  getMediiiaBannerContext,
  getMediiiaBannerUrl,
} from 'shared/constants/mediiiaContextHomeBanner';

const BannerLink = styled.a<{ $hasProductsBelow?: boolean }>`
  display: block;
  margin-top: ${({ $hasProductsBelow }) => ($hasProductsBelow ? 0 : 16)}px;
  margin-bottom: ${({ $hasProductsBelow }) => ($hasProductsBelow ? 0 : 32)}px;
  text-decoration: none;

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 16px;
    margin-bottom: 0;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
      margin-bottom: 8px;
  }
`;

const BannerButton = styled.div`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #f00;
  color: #fff;
  width: fit-content;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.3px;
  cursor: pointer;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export interface MediiiaContextHomeBannerProps {
  hasProductsBelow?: boolean;
  project?: Project;
}

export const MediiiaContextHomeBanner: FC<MediiiaContextHomeBannerProps> = ({
  hasProductsBelow,
  project,
}) => {
  const { t } = useTranslation();

  const bannerContext = useMemo(
    () => getMediiiaBannerContext(project?.tags || []),
    [project?.tags],
  );

  if (!AppTester.isMediiia() || !bannerContext) {
    return null;
  }

  const bannerUrl = getMediiiaBannerUrl(bannerContext);
  if (!bannerUrl) {
    return null;
  }

  return (
    <BannerLink
      href={bannerUrl}
      target="_blank"
      rel="noreferrer"
      $hasProductsBelow={hasProductsBelow}
    >
      <BannerButton>{t(`mediiia_context_home_banner.${bannerContext}`)}</BannerButton>
    </BannerLink>
  );
};
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Project } from '@brg/api';
import { LayoutConst } from 'core';
import { AppTester } from 'supporting';
import {
  getMediiiaBannerContext,
  getMediiiaBannerUrl,
} from 'shared/constants/mediiiaContextHomeBanner';

const BannerLink = styled.a<{ $hasProductsBelow?: boolean }>`
  display: block;
  margin-top: ${({ $hasProductsBelow }) => ($hasProductsBelow ? 0 : 16)}px;
  margin-bottom: ${({ $hasProductsBelow }) => ($hasProductsBelow ? 0 : 32)}px;
  text-decoration: none;

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 16px;
    margin-bottom: 0;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
      margin-bottom: 8px;
  }
`;

const BannerButton = styled.div`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #f00;
  color: #fff;
  width: fit-content;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.3px;
  cursor: pointer;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export interface MediiiaContextHomeBannerProps {
  hasProductsBelow?: boolean;
  project?: Project;
}

export const MediiiaContextHomeBanner: FC<MediiiaContextHomeBannerProps> = ({
  hasProductsBelow,
  project,
}) => {
  const { t } = useTranslation();

  const bannerContext = useMemo(
    () => getMediiiaBannerContext(project?.tags || []),
    [project?.tags],
  );

  if (!AppTester.isMediiia() || !bannerContext) {
    return null;
  }

  const bannerUrl = getMediiiaBannerUrl(bannerContext);
  if (!bannerUrl) {
    return null;
  }

  return (
    <BannerLink
      href={bannerUrl}
      target="_blank"
      rel="noreferrer"
      $hasProductsBelow={hasProductsBelow}
    >
      <BannerButton>{t(`mediiia_context_home_banner.${bannerContext}`)}</BannerButton>
    </BannerLink>
  );
};
